module.exports = __webpack_public_path__ + "static/img/kjsczl@2x.1bdc00b9.png";